import instance, { formDataInstance } from "./baseRequest";

export const heroSectionApi = {
  getHeroSection: async () => instance.get("/hero-section"),
  updateHeroSection: async (mediaFile) => {
    const formData = new FormData();
    if (mediaFile) formData.append("media", mediaFile);
    return formDataInstance.put("/hero-section", formData);
  },
};
